"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showWithTransition = exports.ShowCloseContext = void 0;
var tslib_1 = require("tslib");
var h = require("./createElement").h;
var React = tslib_1.__importStar(require("react"));
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
var helper_1 = require("./helper");
exports.ShowCloseContext = React.createContext(helper_1.emptyFn);
function showWithTransition(_a) {
    var Component = _a.Component, transitionDuration = _a.transitionDuration, autoClose = _a.autoClose, props = _a.props, forcedProps = _a.forcedProps, _b = _a.injectClosePropNames, injectClosePropNames = _b === void 0 ? [] : _b, _c = _a.deepInjectClose, deepInjectClose = _c === void 0 ? [] : _c;
    var div = document.createElement('div');
    document.body.appendChild(div);
    var timer;
    var closed = false;
    injectClosePropNames.forEach(function (key) {
        overrideSingle(props, key);
    });
    deepInjectClose.forEach(function (_a) {
        var reference = _a[0], key = _a[1];
        if (Array.isArray(reference)) {
            reference.forEach(function (obj) { return overrideSingle(obj, key); });
            return;
        }
        overrideSingle(reference, key);
    });
    var currentProps = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, props), forcedProps), { visible: true });
    function overrideSingle(obj, key) {
        var originalValue = obj[key] || helper_1.emptyFn;
        obj[key] = helper_1.inject(originalValue, close);
    }
    function update(newProps) {
        if (closed) {
            return;
        }
        currentProps = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, currentProps), newProps), forcedProps), { visible: true });
        render(currentProps);
    }
    function close() {
        if (closed) {
            return;
        }
        closed = true;
        clearTimeout(timer);
        currentProps = tslib_1.__assign(tslib_1.__assign({}, currentProps), { visible: false });
        render(currentProps);
        setTimeout(function () {
            react_dom_1.default.unmountComponentAtNode(div);
            div.remove();
        }, transitionDuration + 20);
    }
    function render(props) {
        react_dom_1.default.render(h(exports.ShowCloseContext.Provider, { value: close },
            h(Component, tslib_1.__assign({}, props))), div);
    }
    render(currentProps);
    if (autoClose) {
        timer = setTimeout(close, props.duration || 2000);
    }
    return { update: update, close: close };
}
exports.showWithTransition = showWithTransition;
